(() => {
  if (window.__hotSpotController) return;
  window.__hotSpotController = true;

  const mobileQuery = window.matchMedia('(max-width: 999px)');

  /* Capture-phase listener: runs before the x-popover delegate on document.body.
     On mobile we stopPropagation so the popover doesn't open on top of the bottom panel.
     On desktop we do nothing here and let the click bubble to the popover delegate. */
  document.addEventListener(
    'click',
    (e) => {
      const dot = e.target.closest('.hot-spot__dot');
      if (!dot || !mobileQuery.matches) return;

      e.stopPropagation();

      const targetId = dot.getAttribute('data-mobile-target');
      if (!targetId) return;

      const panel = document.getElementById(targetId);
      if (!panel) return;

      /* Scope toggles to the nearest ancestor that contains both the dot and its panel,
       so hotspots in one context don't close hotspots in another. */
      let container = panel.parentElement;
      while (container && !container.contains(dot)) {
        container = container.parentElement;
      }
      if (!container) container = document;

      const isOpen = panel.getAttribute('aria-hidden') === 'false';

      container.querySelectorAll('.hot-spot-mobile-panel').forEach((p) => {
        p.setAttribute('aria-hidden', 'true');
      });
      container.querySelectorAll('.hot-spot__dot').forEach((d) => {
        d.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        panel.setAttribute('aria-hidden', 'false');
        dot.setAttribute('aria-expanded', 'true');
      }
    },
    true,
  );
})();
